import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import store from './store';
import App from './App';
import './index.css';
import '@fontsource/roboto';

const htmlRoot = document.getElementById('root');

if (htmlRoot != null) {
  const root = ReactDOM.createRoot(htmlRoot);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
}
